<template>
	<AppPage>
		<AppPageTitle><h2>Instellingen</h2></AppPageTitle>
		<AppCardPage>
			<Suspense>
				<AppCard>
					<SettingsList />
				</AppCard>
			</Suspense>
		</AppCardPage>
	</AppPage>
</template>
